import { KeycloakConfig } from 'keycloak-angular';

export const environment = {
    production: false,
    maxSizeUploadFile: 15242880,
    reCaptchaSikeKey: '6LeAXwAVAAAAADQ8mqjN1UUGJBvlsxoerTtq2ylB'
};
